import React, { memo, useCallback, useRef } from 'react'

import { TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store'
import { setMinPrice, setMaxPrice } from 'Pods/SearchPage/Store/actions/pricing'
import { DEFAULT_STATE } from 'Pods/SearchPage/Store/constants'

function PriceInputs() {
  const translate = useTranslate()

  const minPrice = useSearchPageStore(state => state.minPrice)
  const maxPrice = useSearchPageStore(state => state.maxPrice)
  const trackFilterSelect = useTrackFilterSelect()
  const trackedRangeRef = useRef('')

  // Reported when a field is left rather than per keystroke, with the backend range token.
  const trackCustomRange = useCallback((min, max) => {
    let range = ''
    if (max !== '') {
      range = `range_${min || 0}_${max}`
    } else if (min !== '') {
      range = `more_than_${min}`
    }
    if (range && range !== trackedRangeRef.current) {
      trackFilterSelect(FILTER_NAME.PRICE, range)
    }
    trackedRangeRef.current = range
  }, [trackFilterSelect])

  const handleMinPriceChange = useCallback((e) => {
    const value = e.target.value
    if (value === '') {
      setMinPrice(value)

      return
    }

    const numValue = parseInt(value, 10)
    if (!Number.isNaN(numValue) && numValue >= 0) {
      setMinPrice(numValue)
    }
  }, [])

  const handleMaxPriceChange = useCallback((e) => {
    const value = e.target.value
    if (value === '') {
      setMaxPrice(value)

      return
    }

    const numValue = parseInt(value, 10)
    if (!Number.isNaN(numValue) && numValue >= 0) {
      setMaxPrice(numValue)
    }
  }, [])

  const handleMinPriceBlur = useCallback(() => {
    if (minPrice !== '' && maxPrice !== '' && minPrice > maxPrice) {
      setMaxPrice(DEFAULT_STATE.maxPrice)
      trackCustomRange(minPrice, DEFAULT_STATE.maxPrice)
      return
    }
    trackCustomRange(minPrice, maxPrice)
  }, [minPrice, maxPrice, trackCustomRange])

  const handleMaxPriceBlur = useCallback(() => {
    if (minPrice !== '' && maxPrice !== '' && maxPrice < minPrice) {
      setMinPrice(DEFAULT_STATE.minPrice)
      trackCustomRange(DEFAULT_STATE.minPrice, maxPrice)
      return
    }
    trackCustomRange(minPrice, maxPrice)
  }, [minPrice, maxPrice, trackCustomRange])

  return (
    <div className="price-filter__price-inputs">
      <TextInput
        id="min-price"
        label={translate('search_page.filters.price.min_price')}
        inputType="number"
        size="tiny"
        type="primary"
        value={minPrice}
        onChange={handleMinPriceChange}
        onBlur={handleMinPriceBlur}
        step="1"
        isCurrency
        isPilot
        wrapperClassName="price-filter__price-input"
      />
      <TextInput
        id="max-price"
        label={translate('search_page.filters.price.max_price')}
        inputType="number"
        size="tiny"
        type="primary"
        value={maxPrice}
        onChange={handleMaxPriceChange}
        onBlur={handleMaxPriceBlur}
        step="1"
        isCurrency
        isPilot
        wrapperClassName="price-filter__price-input"
      />
    </div>
  )
}

export default memo(PriceInputs)
